var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolusFooterButterfly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 239,
    viewBox: "0 0 286 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 251H86.9854C128.386 250.663 160.55 223.989 160.55 165.758V146.768C159.807 56.194 90.1805 0.326252 0.0225001 0V132.109C0.0225001 148.242 -0.416255 183.961 52.324 183.961H69.1203V188.18H29.2051C13.0726 188.18 0 201.252 0 217.385V251Z",
    fill: "#050505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.442 251H238.456C197.056 250.663 164.892 223.989 164.892 165.758V146.768C165.623 56.194 235.261 0.326252 325.419 0V132.109C325.419 148.242 325.858 183.961 273.118 183.961H256.321V188.18H296.236C312.369 188.18 325.442 201.252 325.442 217.385V251Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolusFooterButterfly);
export default __webpack_public_path__ + "static/media/evolus-footer-butterfly.145ec2c9f3f0bc8edc321aa54b45d1ea.svg";
export { ForwardRef as ReactComponent };